import { render, staticRenderFns } from "./myPosition.vue?vue&type=template&id=2631d804"
import script from "./myPosition.vue?vue&type=script&lang=js"
export * from "./myPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports